import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "@phosphor-icons/react";
import { t } from "../i18n";
import { SERVICES } from "../data";
import { fadeUp, stagger, viewport } from "../motion";

export default function Services() {
  const s = t.de.servicesSection;
  return (
    <section id="services" data-testid="services" className="py-24 md:py-36 bg-[#F8F9FA]">
      <div className="container mx-auto px-6 md:px-12 max-w-7xl">
        <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={viewport} className="max-w-2xl mb-16">
          <motion.div variants={fadeUp} className="flex items-center gap-3 mb-6">
            <span className="h-px w-10 bg-gold-500" />
            <span className="text-xs font-semibold uppercase tracking-[0.25em] text-gold-600">{s.overline}</span>
          </motion.div>
          <motion.h2 variants={fadeUp} className="text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-navy-900 leading-tight">
            {s.title}
          </motion.h2>
        </motion.div>

        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.1 }}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"
        >
          {SERVICES.map((svc) => {
            const Icon = svc.icon;
            return (
              <motion.div key={svc.slug} variants={fadeUp}>
                <Link
                  to={`/leistungen/${svc.slug}`}
                  data-testid={`service-card-${svc.slug}`}
                  className="group h-full flex flex-col p-8 md:p-9 rounded-3xl bg-white border border-slate-100 transition-all duration-500 hover:shadow-[0_24px_50px_rgb(10,17,40,0.09)] hover:-translate-y-2"
                >
                  <div className="w-14 h-14 rounded-2xl bg-gold-50 flex items-center justify-center mb-6 transition-colors group-hover:bg-gold-500">
                    <Icon size={28} weight="light" className="text-gold-600 transition-colors group-hover:text-white" />
                  </div>
                  <h3 className="text-xl font-outfit font-medium text-navy-900 mb-3">{svc.title}</h3>
                  <p className="text-slate-500 leading-relaxed flex-1">{svc.short}</p>
                  <span className="mt-6 inline-flex items-center gap-2 text-sm font-medium text-navy-900 group-hover:text-gold-600 transition-colors">
                    {s.learn}
                    <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
                  </span>
                </Link>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
}
